<template>
  <RfDialog ref="dialog" :title="title" :width="800" hideConfirm cancelText="Done" @close="onClose">
    <component
      :is="codeEditor.CodeEditor"
      v-bind="{ ...codeEditor.props, languages: codeEditor.languages(language) }"
      :modelValue="code"
      height="55vh"
      fontSize="13px"
      @update:modelValue="value => emit('update:code', value)"
    ></component>
  </RfDialog>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { useCodeEditor } from "@/utils/composables/useCodeEditor";
import RfDialog from "@/components/modals/RfDialog.vue";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  code: { type: String, default: "" },
  language: { type: String, default: "html" },
  title: { type: String, default: "Edit" },
});
const emit = defineEmits(["update:modelValue", "update:code"]);

const codeEditor = useCodeEditor();
const dialog = ref(null);

watch(
  () => props.modelValue,
  isOpen => (isOpen ? dialog.value?.open() : dialog.value?.close()),
);

// Sync the initial open state after the RfDialog ref is populated; an immediate
// watcher would run during setup before the ref exists and silently no-op.
onMounted(() => {
  if (props.modelValue) dialog.value?.open();
});

const onClose = () => emit("update:modelValue", false);
</script>
